import React from 'react';
import './Footer.scss';
import { CONTACTS } from '../../config/contacts';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Main Footer Content */}
        <div className="footer__content">
          {/* Company Info */}
          <div className="footer__section footer__section--about">
            <img src="/logo/logo.png" alt="77Gestão" className="footer__logo" />
            <p className="footer__description">
              Sistema completo de gestão empresarial para automatizar e 
              profissionalizar sua empresa.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="footer__section">
            <h3 className="footer__title">Navegação</h3>
            <ul className="footer__links">
              <li><a href="/">Início</a></li>
              <li><a href="/#como-funciona">Como funciona</a></li>
              <li><a href="/#precos">Preços</a></li>
              <li><a href="/funcionalidades">Funcionalidades</a></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div className="footer__section">
            <h3 className="footer__title">Recursos</h3>
            <ul className="footer__links">
              <li>
                <a href="https://blog.77gestao.com.br/" target="_blank" rel="noopener noreferrer">
                  Blog <i className="fas fa-external-link-alt"></i>
                </a>
              </li>
              <li>
                <a href="https://app.77gestao.com.br/login?source=footer" target="_blank" rel="noopener noreferrer">
                  Acesso ao sistema
                </a>
              </li>
              <li>
                <a href="https://app.77gestao.com.br/cadastro?source=footer" target="_blank" rel="noopener noreferrer">
                  Criar conta
                </a>
              </li>
              <li>
                <a href={CONTACTS.whatsapp.getUrl('Gostaria de agendar uma demonstração do sistema')} target="_blank" rel="noopener noreferrer">
                  Agendar demonstração
                </a>
              </li>
              <li>
                <a href={CONTACTS.whatsapp.getUrl('Preciso de suporte técnico')} target="_blank" rel="noopener noreferrer">
                  Suporte
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__section">
            <h3 className="footer__title">Contato</h3>
            <ul className="footer__contact">
              <li>
                <i className="fas fa-phone"></i>
                <a href={`tel:${CONTACTS.whatsapp.number}`}>{CONTACTS.phone}</a>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a>
              </li>
              <li>
                <i className="fab fa-whatsapp"></i>
                <a href={CONTACTS.whatsapp.getUrl('')} target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__bottom-content">
            <p className="footer__copyright">
              © {currentYear} 77Gestão. Todos os direitos reservados.
            </p>
            <div className="footer__legal">
              <a href="https://app.77gestao.com.br/assets/politica-privacidade.pdf" target="_blank" rel="noopener noreferrer">
                Política de Privacidade
              </a>
              <span className="footer__separator">•</span>
              <a href="https://app.77gestao.com.br/assets/termos.pdf" target="_blank" rel="noopener noreferrer">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
